module.exports = __webpack_public_path__ + "static/logos-tiles-georges-b5bcd545364805a59d41c59d21cba22a.svg";